import { getUrl } from "@tootools/http-utils";
import { SearchableWorkspace, Workspace } from "@radarly/models/workspace";
import { RadarlyAPI } from "./base";

interface Pagination {
  start: number;
  limit: number;
}

function getPageFromPagination(pagination: Partial<Pagination>) {
  return Math.round(
    (pagination.start || 0) / getLimitFromPagination(pagination)
  );
}

function getLimitFromPagination(pagination: Partial<Pagination>) {
  return pagination.limit || 15;
}

function getSearchWorkspaceUrl(
  search: string,
  pagination: Partial<Pagination>
) {
  const page = getPageFromPagination(pagination);
  return getUrl(`/dashboards/search.json`, {
    query: search,
    page,
    nb: getLimitFromPagination(pagination),
  });
}

interface ProjectWorkspacesResponse {
  dashboards: Workspace[];
}

interface SearchWorkspacesResponse {
  dashboards: SearchableWorkspace[];
}

export class WorkspaceAPI extends RadarlyAPI {
  public async getProjectWorkspaces(project: number) {
    return await this.get<ProjectWorkspacesResponse>(
      `/projects/${project}/dashboards.json`
    ).then(({ dashboards }) => dashboards);
  }
  public async searchWorkspaces(
    search: string,
    pagination: Partial<Pagination> = {}
  ) {
    return await this.get<SearchWorkspacesResponse>(
      getSearchWorkspaceUrl(search, pagination)
    );
  }
}
